//
export default [
	{
		text: '#',
		value: 'id',
	},
	{
		text: 'fecha',
		value: 'bank_card_date',
		align: 'right',
		format: 'date',
	},
	{
		text: 'movimiento',
		value: 'bank_card_movement_detail',
	},
	{
		text: 'monto',
		value: 'amount_computed',
		align: 'right',
		format: 'currency',
	},
	{
		text: 'asiento',
		value: 'accounting_seat_code',
		align: 'right',
	},
	{
		text: 'responsable',
		value: 'g_user_name_case',
		align: 'right',
	},
]